module.exports = __webpack_public_path__ + "img/linkedin.a39c600a.svg";